import { ReactComponent as PlusIcon } from "../../../assets/icons/Plus.svg";
import Search from "../Search/Search";
import { Dropdown } from "../FilterComponents/Dropdown";

const CompanyPageHead = ({
  openModal,
  search,
  filter,
  searchData,
  dataSearchValues,
  DATA_SEARCH_VALUE,
}) => {
  return (
    <div className="consultation-header-filter-container">
      <div className="teacher-page-add-btn">
        <div className="consultation-header-filter">
          <div className="consultation-top-filter">
            {search && (
              <Search
                searchData={searchData}
                dataSearchValues={dataSearchValues}
                className="search-input-con desktop"
                DATA_SEARCH_VALUE={DATA_SEARCH_VALUE}
              />
            )}

            <Dropdown type="contractType" />
            <div className="lesson-table-btn-container teacher ">
              <button className="add-detail" onClick={() => filter()}>
                Tətbiq et
              </button>
            </div>
          </div>
        </div>
        <button className="add-detail" onClick={openModal}>
          <PlusIcon />
          Əlavə et
        </button>
      </div>
    </div>
  );
};

export default CompanyPageHead;
